/**
 * Analytics event descriptions for when user gets a fraud modal.
 */
export var DENIED_OR_WARNED_EVENT_NAME = {
    DENIED: 'tre return denied',
    WARNED: 'tre return warning',
    WARNEDINVALID: 'tre return warning',
};
/**
 * Analytics event descriptions for when user copies text to clipboard.
 */
export var COPY_TEXT_EVENT_DESCRIPTION = {
    DENIED: 'tre return denied overlay: copy text to clipboard click',
    WARNED: 'tre return warning overlay: copy text to clipboard click',
    WARNEDINVALID: 'tre return warning overlay: copy text to clipboard click',
};
